export default __webpack_public_path__ + "static/media/error-icon.5fb492ef.png";